import getCurrencySymbol from 'Shared/util/getCurrencySymbol';
import formatPrice from 'Shared/util/formatPrice';

import sortBy from 'lodash/sortBy';
import forEachObject from 'lodash/forEach';
import uniq from 'lodash/uniq';

const getId = () => {
  const length = 9;
  const prefix = 'tree-js-prefix-';
  return prefix + Math.random().toString(36).substr(2, length);
};

const getValue = (dateColumnsPeriod, arr = [], currency) => {
  return dateColumnsPeriod.map((period) => {
    let item = { status: null, val: '-', id: getId(), period };

    const findElement = arr.find((item) => period === item.period && currency === item.currency);
    if (findElement) {
      item.val = getCurrencySymbol(findElement.currency) + formatPrice((+findElement.amount).toFixed(2));
    }
    return item;
  });
};

const getValueByProject = (projectName, dateColumnsPeriod, arr) => {
  return dateColumnsPeriod.map((period) => {
    let item = { status: null, val: '-', id: getId(), period };

    const findElement = arr.find((item) => period === item.period && projectName === item.project);
    if (findElement) {
      item.val = getCurrencySymbol(findElement.currency) + formatPrice((+findElement.amount).toFixed(2));
    }
    return item;
  });
};

const getChildren = (dateColumnsPeriod, dataChildren, compareBy, currency) => {
  if (dataChildren?.length > 0) {
    let objUniqProjects = {};
    let cashReceiptCustomersChildren = [];
    let temptProjectName = '';
    let dataChildrenSorted = sortBy(dataChildren, compareBy);

    // Sorting a collection by project (compareBy = "project")
    // before
    // 1) [{name: "Project 1": val: 10},{name: "Project 1": val: 20},{name: "Project 2": val: 15}]
    // after
    // 2) {
    //     "Project 1" : [{name: "Project 1": val: 10}, {name: "Project 1": val: 20}],
    //     "Project 2" : [{name: "Project 2": val: 15}]
    //    }
    dataChildrenSorted.forEach((prj) => {
      if (temptProjectName !== prj[compareBy]) {
        objUniqProjects[prj[compareBy]] = [prj];
      } else if (temptProjectName === prj[compareBy]) {
        objUniqProjects[prj[compareBy]] = [...objUniqProjects[prj[compareBy]], prj];
      }
      temptProjectName = prj[compareBy];
    });

    // Formatting data for tree
    forEachObject(objUniqProjects, (values, key) => {
      let obj = {
        id: getId(),
        name: key,
        value: [],
      };

      // Add a cell by the amount of dateColumnsPeriod and create empty cells if there is no data
      obj.value = dateColumnsPeriod.map((period) => {
        let item = { status: null, val: '-', id: getId(), period };

        const findElement = values.find((item) => period === item.period && currency === item.currency);
        if (findElement) {
          item.val = getCurrencySymbol(findElement.currency) + formatPrice((+findElement.amount).toFixed(2));
        }
        return item;
      });
      cashReceiptCustomersChildren.push(obj);
    });
    return [...cashReceiptCustomersChildren];
  }
};

const getChildrenByProject = (nameProject, dateColumnsPeriod, dataChildren, compareBy) => {
  if (dataChildren?.length > 0) {
    let objUniqProjects = {};
    let cashReceiptCustomersChildren = [];
    let dataChildrenSorted = sortBy(dataChildren, compareBy);

    dataChildrenSorted.forEach((prj) => {
      if (prj.project === nameProject) {
        if (!objUniqProjects[prj[compareBy]]?.length) {
          objUniqProjects[prj[compareBy]] = [prj];
        } else {
          objUniqProjects[prj[compareBy]] = [...objUniqProjects[prj[compareBy]], prj];
        }
      }
    });

    // Formatting data for tree
    forEachObject(objUniqProjects, function (values, key) {
      let obj = {
        id: key,
        name: key,
        value: [],
      };
      // Add a cell by the amount of dateColumnsPeriod and create empty cells if there is no data
      obj.value = dateColumnsPeriod.map((period) => {
        let item = { status: null, val: '-', id: period, period };

        const findElement = values.find((item) => period === item.period && nameProject === item.project);
        if (findElement) {
          item.val = getCurrencySymbol(findElement.currency) + formatPrice((+findElement.amount).toFixed(2));
        }
        return item;
      });
      cashReceiptCustomersChildren.push(obj);
    });
    return [...cashReceiptCustomersChildren];
  }
};

const filterOutEmptyPeriods = (originalPeriod, data, emptyPeriod = '-') => {
  return originalPeriod.filter((__, i) => {
    return !data.every((item) => item.value[i]?.val === emptyPeriod || item.value[i] === undefined);
  });
};

const filterOutEmptyPeriodsChildren = (originalPeriod, data, emptyPeriod = '-') => {
  return originalPeriod.filter((__, i) => {
    return !data.every((item) => {
      if (item.children) {
        return item.children.every((item2) => item2.value[i]?.val === emptyPeriod || item.value[i] === undefined);
      }
      return false;
    });
  });
};

const slicePeriod = (fullPeriod, partOfPeriod) => {
  const end = fullPeriod.indexOf(partOfPeriod[partOfPeriod.length - 1]) + 1;
  const start = fullPeriod.indexOf(partOfPeriod[0]);
  return fullPeriod.slice(start, end);
};

const getTempPeriod = (tempPeriod, fullPeriod, dateColumnsPeriod, object) => {
  tempPeriod = uniq([...tempPeriod, ...filterOutEmptyPeriods(fullPeriod || dateColumnsPeriod, [object])]);
  return slicePeriod(fullPeriod, tempPeriod);
};

const extractPeriodArray = (treeArray) => {
  const getElement = treeArray[0];
  return getElement.value.map((item) => item.period);
};

export {
  getId,
  getValue,
  getValueByProject,
  getChildren,
  getChildrenByProject,
  filterOutEmptyPeriods,
  filterOutEmptyPeriodsChildren,
  slicePeriod,
  getTempPeriod,
  extractPeriodArray,
};
